import app from "./servicer/app.js";
import permission from "./servicer/permission.js";
import role from "./servicer/role.js";
import user from "./servicer/user.js";

export default {
    app,
    permission,
    role,
    user
};